import { render, staticRenderFns } from "./case-list-details.vue?vue&type=template&id=75e397f4&scoped=true"
import script from "./case-list-details.vue?vue&type=script&lang=js"
export * from "./case-list-details.vue?vue&type=script&lang=js"
import style0 from "./case-list-details.vue?vue&type=style&index=0&id=75e397f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e397f4",
  null
  
)

export default component.exports